import { useLazyGetOrderSensorsQuery, useLazyGetSensorStatusesQuery } from "store/api/widgetsApi"
import { FeatureFlag, isFeatureEnabled } from "store/featureFlagsSlice"
import { useAppSelector } from "store/hooks"

import { WidgetOrderedSensors } from "components/widgets/WidgetOrderedSensors"
import { WidgetSensorStatuses } from "components/widgets/WidgetSensorStatuses"

import { DashboardWidgetSection } from "../components/Dashboard/Dashboard"

export const SensorsSection = () => {
  const sensorsOrderingEnabled = useAppSelector(isFeatureEnabled(FeatureFlag.SensorsOrdering))

  if (!sensorsOrderingEnabled) return null

  return (
    <DashboardWidgetSection title="Sensors">
      <WidgetOrderedSensors useLazyQuery={useLazyGetOrderSensorsQuery} />
      <WidgetSensorStatuses useLazyQuery={useLazyGetSensorStatusesQuery} />
    </DashboardWidgetSection>
  )
}
